import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class CommunicationService {

    private userSource = new Subject<any>();

    userHandler = this.userSource.asObservable();

    setUser(user: any) {
        this.userSource.next(user);
    }
}
